import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './FieldWorkOrderDetails.css';
import Date from 'components/shared/text/Date';
import FieldWorkOrderGCForm from 'components/admin/projects/details/project-daily-report-log/FieldWorkOrderGCForm';

class FieldWorkOrderDetails extends Component {
  static propTypes = {
    fieldWorkOrder: PropTypes.shape({}),
    fieldWorkOrderForm: PropTypes.shape({}),
    handleAttributeChange: PropTypes.func.isRequired,
    fieldWorkOrderEdit: PropTypes.bool.isRequired,
    showErrorMessage: PropTypes.bool.isRequired,
  };

  status = {
    pending: 'Pending',
    sub_approved: 'Sub-Approved',
    gc_approved: 'GC-Approved',
    sub_denied: 'Sub-Denied',
    gc_denied: 'GC-Denied',
  };

  render() {
    const {
      fieldWorkOrder,
      fieldWorkOrderForm,
      handleAttributeChange,
      fieldWorkOrderEdit,
      showErrorMessage,
    } = this.props;
    return (
      <div className="field-work-order-details">
        <div className="fwo-number-field">
          <p className="fwo-field-label">FWO #</p>
          <div className="fwo-block-content">{fieldWorkOrder.number}</div>
        </div>
        {((fieldWorkOrder.preset_tasks &&
          fieldWorkOrder.preset_tasks.length > 0) ||
          fieldWorkOrder.preset_task_other) && (
          <div className="fwo-field">
            <p className="fwo-field-label">Tasks to be performed</p>
            <div className="fwo-block-content">
              <ul>
                {fieldWorkOrder.preset_tasks.length > 0 &&
                  fieldWorkOrder.preset_tasks.map((task) => (
                    <li key={task.id}>{task.label}</li>
                  ))}
                {fieldWorkOrder.preset_task_other && (
                  <li>{fieldWorkOrder.preset_task_other}</li>
                )}
              </ul>
            </div>
          </div>
        )}
        <div className="fwo-field">
          <p className="fwo-field-label">Work to be performed</p>
          <div className="fwo-block-content">
            {fieldWorkOrder.work_performed}
          </div>
        </div>
        {!!fieldWorkOrder.comments && (
          <div className="fwo-field">
            <p className="fwo-field-label">Comments</p>
            <div className="fwo-block-content">{fieldWorkOrder.comments}</div>
          </div>
        )}
        <div className="fwo-field">
          <p className="fwo-field-label">Start date</p>
          <div className="fwo-block-content">
            {!!fieldWorkOrder.start_date ? (
              <Date
                className="fwo-date-field"
                value={fieldWorkOrder.start_date}
                format="MM/DD/YYYY"
              />
            ) : (
              'TBD'
            )}
          </div>
        </div>
        <div className="fwo-field">
          <p className="fwo-field-label">Completion date</p>
          <div className="fwo-block-content">
            {!!fieldWorkOrder.completion_date ? (
              <Date
                className="fwo-date-field"
                value={fieldWorkOrder.completion_date}
                format="MM/DD/YYYY"
              />
            ) : (
              'TBD'
            )}
          </div>
        </div>
        <div className="fwo-field">
          <p className="fwo-field-label">Cost Impact</p>
          <div className="fwo-block-content">
            {fieldWorkOrder.cost_impact ? 'Yes' : 'No'}
          </div>
        </div>
        {fieldWorkOrder.cost && (
          <div className="fwo-field">
            <p className="fwo-field-label">Cost</p>
            <div className="fwo-block-content">{fieldWorkOrder.cost}</div>
          </div>
        )}
        <div className="fwo-field">
          <p className="fwo-field-label">Delay</p>
          <div className="fwo-block-content">
            {fieldWorkOrder.delay ? 'Yes' : 'No'}
          </div>
        </div>
        {fieldWorkOrder.delay && (
          <div className="fwo-field">
            <p className="fwo-field-label">Delay reason</p>
            <div className="fwo-block-content">
              {fieldWorkOrder.delay_reason}
            </div>
          </div>
        )}
        <div className="fwo-field">
          <p className="fwo-field-label">Labor</p>
          <div className="fwo-block-content">{fieldWorkOrder.labor}</div>
        </div>
        {!!fieldWorkOrder.materials && (
          <div className="fwo-field">
            <p className="fwo-field-label">Materials</p>
            <div className="fwo-block-content">{fieldWorkOrder.materials}</div>
          </div>
        )}
        {!fieldWorkOrderEdit ? (
          <div>
            <div className="fwo-field">
              <p className="fwo-field-label">Status</p>
              <div className="fwo-block-content">
                {this.status[fieldWorkOrder.status]}
              </div>
            </div>
            {(fieldWorkOrder.status === 'sub_denied' ||
              fieldWorkOrder.status === 'gc_denied') && (
              <div className="fwo-field">
                <p className="fwo-field-label">Denied reason</p>
                <div className="fwo-block-content">
                  {fieldWorkOrder.denied_reason}
                </div>
              </div>
            )}
          </div>
        ) : (
          <FieldWorkOrderGCForm
            fieldWorkOrderForm={fieldWorkOrderForm}
            handleAttributeChange={handleAttributeChange}
            showErrorMessage={showErrorMessage}
          />
        )}
      </div>
    );
  }
}

export default FieldWorkOrderDetails;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/FieldWorkOrderDetails.js